export const SET_USER_BRAND = "SET_USER_BRAND";

export function setUserBrand(userBrand) {
	return { type: SET_USER_BRAND, userBrand };
}
